import * as type from '../actions/types';

const initialState = {
    chat: {},
    loading: false,
    error: null,
}

export default function currentChat(state = initialState, action) {
    switch (action.type) {
        case type.GET_CHAT_DATA_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.GET_CHAT_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                chat: action.data,
            }
        case type.GET_CHAT_DATA_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}